module.exports = __webpack_public_path__ + "static/media/REWARDS@3x.1a7e7717.png";